import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { env } from "./config/env";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    ZCA_GA_MEASUREMENT_ID?: string;
  }
}

let initialized = false;

function analyticsEnabled() {
  return Boolean(
    env.googleAnalyticsMeasurementId ||
    (typeof window !== "undefined" ? window.ZCA_GA_MEASUREMENT_ID : "")
  );
}

export function initAnalytics() {
  if (!analyticsEnabled() || initialized || typeof window === "undefined") return;

  initialized = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag(...args: unknown[]) {
    window.dataLayer?.push(args);
  };

  if (!window.ZCA_GA_MEASUREMENT_ID) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(env.googleAnalyticsMeasurementId)}`;
    document.head.appendChild(script);

    window.gtag("js", new Date());
    window.gtag("config", env.googleAnalyticsMeasurementId, {
      send_page_view: false,
    });
  }
}

export function trackPageView(path: string, title = document.title) {
  if (typeof window.gtag !== "function") initAnalytics();
  if (!analyticsEnabled() || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title,
    page_location: window.location.href,
  });
}

export type CtaAction = "donate" | "schedule_visit" | "apply" | "parent_portal" | "contact" | "custom";

export function trackCta(action: CtaAction, label: string, extra: Record<string, string> = {}) {
  if (!analyticsEnabled() || typeof window.gtag !== "function") return;
  window.gtag("event", `cta_${action}`, {
    event_category: "public_web_cta",
    event_label: label,
    cta_label: label,
    ...extra,
  });
}

export function AnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    window.setTimeout(() => trackPageView(path), 0);
  }, [location.pathname, location.search]);

  return null;
}
